import { useContext, useEffect, useState } from 'react'
import { observer } from 'mobx-react-lite'
// import styled from 'styled-components'

import { PARAM_SORT_KEYS } from '../../constants'
import type { PARAM_SORT_TYPE } from '../../constants'

import { onParams } from '../../utils'

import { StoresContext } from '../../provider/StoreProvider'

// import { Card, Text } from '../../../components/atoms'
// import { SaleOffCard } from '../../../components/molecules'
// import { Sort } from '../../../components/organisms'
// import { PagingContent } from '../../../components/pagingList'

// import { Color } from '../../../theme/color'

// import { ReactComponent as GraphIcon } from '../../../assets/gui/rise_40.svg'
// import { ReactComponent as ClockIcon } from '../../../assets/gui/clock_40.svg'
import { EmptyPage } from '../../components/exception/EmptyPage'

// const sortList: { type: PARAM_SORT_TYPE; title: string }[] = [
//   {
//     type: PARAM_SORT_KEYS.LATEST,
//     title: '최근순',
//   },
//   {
//     type: PARAM_SORT_KEYS.OLDEST,
//     title: '과거순',
//   },
// ]

export const MainSaleOffList = observer(() => {
  const { marketStore } = useContext(StoresContext)
  // const mainStore = homeStore.mainStore
  const pagingStore = marketStore.productPagingStore

  const [sortType] = useState<PARAM_SORT_TYPE>(PARAM_SORT_KEYS.LATEST)

  // useEffect(() => {
  //   pagingStore.load({ param: { status: 'FINISH' } }, true)
  // }, [])

  // useEffect(() => {
  //   onParams({
  //     sortType,
  //     store: pagingStore,
  //     status: 'FINISH',
  //   })
  // }, [sortType])

  // const getRevenueRate = () => {
  //   const revenueRate = mainStore.content?.sellHistory?.revenueRate
  //   if (revenueRate == null) {
  //     return '-'
  //   }
  //   const revenueRateString = amountString(String(revenueRate), false, 2)
  //   return revenueRate > 0 ? `+ ${revenueRateString}%` : `${revenueRateString.replace('-', '- ')}%`
  // }

  // TODO: 추후 해제
  return <EmptyPage content="조회 가능한 내역이 없습니다." />

  // return (
  //   <Wrap>
  //     <HistoryCardContainer>
  //       <Card $padding="16px 24px" $radius={8} $background="white" $shadow="0 4px 6px 0 rgba(0, 0, 0, 0.05)">
  //         <GraphIcon />
  //         <div>
  //           <Text size={12} color="text_secondary">
  //             평균 수익률
  //           </Text>
  //           <Text size={18} weight={600} color="primary_5">
  //             {getRevenueRate()}
  //           </Text>
  //         </div>
  //       </Card>
  //       <Card $padding="16px 24px" $radius={8} $background="white" $shadow="0 4px 6px 0 rgba(0, 0, 0, 0.05)">
  //         <ClockIcon />
  //         <div>
  //           <Text size={12} color="text_secondary">
  //             평균 보유기간
  //           </Text>
  //           <Text size={18} weight={600} color="primary_5">
  //             -- 일
  //           </Text>
  //         </div>
  //       </Card>
  //     </HistoryCardContainer>
  //     <PagingContent pagingStore={pagingStore}>
  //       <ProductsContainer>
  //         <SortContainer>
  //           <Sort sortType={sortType} sortList={sortList} setSortType={setSortType} />
  //         </SortContainer>
  //         {/* TODO: API 미구현 */}
  //         {/* <PagingContent pagingStore={pagingStore}>
  //           <ProductsList>
  //             {pagingStore.list.map(({ id, artist, name }) => (
  //               <SaleOffCard key={id} artist={artist} title={name} />
  //             ))}
  //           </ProductsList>
  //         </PagingContent> */}
  //       </ProductsContainer>
  //     </PagingContent>
  //   </Wrap>
  // )
})

// const Wrap = styled.div`
//   display: flex;
//   flex-direction: column;
//   height: 100%;
// `

// const HistoryCardContainer = styled.div`
//   display: grid;
//   grid-template-columns: 1fr 1fr;
//   column-gap: 16px;
//   padding: 24px 16px;
//   > div {
//     display: flex;
//     align-items: center;
//     gap: 8px;
//     & > div {
//       display: flex;
//       flex-direction: column;
//       gap: 2px;
//     }
//   }
// `

// const ProductsContainer = styled.article`
//   display: flex;
//   flex-direction: column;
//   flex-basis: 100%;
//   padding-bottom: 24px;
//   border-top-right-radius: 24px;
//   border-top-left-radius: 24px;
//   background-color: ${Color.white};
// `

// const SortContainer = styled.div`
//   display: flex;
//   justify-content: flex-end;
//   padding: 16px;
// `

// const ProductsList = styled.div`
//   display: flex;
//   flex-direction: column;
//   gap: 24px;
// `
